import { CSSProperties } from 'react';

import { K8sProvider } from '@cast/shared-types';

import {
  AksIcon,
  AnywhereIcon,
  EksIcon,
  GkeIcon,
  KopsIcon,
  KubernetesIcon,
  RosaIcon,
} from '../../assets/icons';

type Props = {
  provider?: `${K8sProvider}`;
  size: number | string;
  className?: string;
  style?: CSSProperties;
};

const clusterIconMapper: Record<`${K8sProvider}`, typeof AksIcon> = {
  gke: GkeIcon,
  eks: EksIcon,
  aks: AksIcon,
  kops: KopsIcon,
  openshift: RosaIcon,
  anywhere: AnywhereIcon,
  self_hosted_with_ec2_nodes: KubernetesIcon,
  oke: KubernetesIcon,
};

export const K8sProviderIcon = ({
  provider,
  size,
  className,
  style,
}: Props) => {
  const ClusterIcon =
    (provider && clusterIconMapper[provider]) ?? KubernetesIcon;

  return (
    <ClusterIcon
      height={size}
      width={size}
      className={className}
      style={style}
      data-provider={provider}
      data-testid={`${provider}-icon`}
    />
  );
};
